// extracted by mini-css-extract-plugin
export default {"componentWrapper":"NoMatch_componentWrapper__wq2t1"};